<template>
<div id="cartaporte">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="mdi-cash" title="Nuevo Pago Multiple" class="elevation-1 ">

                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <div style="width:95%; position:absolute; top:0px;">
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-alert color="green" outlined dense type="info"><span style="font-size:10px;">Si no se específica la Serie y Folio el sistema asignara en automático el de la configuración.</span></v-alert>

                                        </v-col>

                                    </v-row>
                                    <v-row style="width:100%; position:absolute; top:45px; left:10px;">
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-if="series.length==0" v-model="model.serie" label="Serie"></v-text-field>
                                            <v-autocomplete v-if="series.length>0" v-model="model.serie" label="Serie" :items="series" clearable item-text="text" item-value="id">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-model="model.folio" label="Folio"></v-text-field>
                                        </v-col>
                                    </v-row>

                                </div>
                                <p />
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <h5><b>Emisor</b> </h5><span class="title">{{model.emisor.rfc}} - {{model.emisor.razon_social}}</span>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="model.FechaFactura" label="Fecha Factura" readonly v-bind="attrs" v-on="on" @click:clear="model.FechaFactura = null"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.FechaFactura" no-title locale="MX" @change="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.receptor" label="Receptor" return-object :items="receptores" :hide-no-data="true" item-text="razon_social" item-value="uuid" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.rfc}} - {{ item.razon_social}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.rfc}} - {{ item.razon_social}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>

                                <p />
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="model.FechaPago" label="Fecha Pago" readonly v-bind="attrs" v-on="on" @click:clear="model.FechaPago = null"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.FechaPago" no-title locale="MX" @change="menu1 = false"></v-date-picker>
                                        </v-menu>

                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.FormaPago" label="Forma Pago" :items="FormasPago" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <p />
                            <v-client-table key="actualiza" ref="vuetable" :data="data_pagos" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <div style="width: 20px !important;">
                                        <v-btn color="secondary" fab x-small dark title="EDITAR" @click="open(props.row, props.index)">
                                            <v-icon small>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>

                            </v-client-table>

                            <v-dialog v-model="modal" max-width="600px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Editar Pago</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-form ref="form">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col sm="12" md="12" lg="12">
                                                                <v-text-field v-model="model.UUID" label="Folio Fiscal UUID" readonly :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col sm="6" md="6" lg="6">
                                                                <v-text-field v-model="model.Pago.No" label="Número de Parcialidad" :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col sm="6" md="6" lg="6">
                                                                <v-text-field v-model="model.Pago.Saldo" @change="actualizaSaldo" label="Importe Saldo Anterior" :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col sm="6" md="6" lg="6">
                                                                <v-text-field v-model="model.Pago.Pagado" @change="actualizaSaldo" label="Importe Pagado" :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col sm="6" md="6" lg="6">
                                                                <v-text-field v-model="model.Pago.Insoluto" label="Importe Saldo Insoluto" :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <p />
                                                        <p />
                                                        <h5>IMPUESTOS</h5>
                                                        <v-row>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <h5 style="color:green">IVA TRASLADADO </h5>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="iva_traslado" label="Tasa" ></v-text-field>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="importe_iva_traslado" label="Importe" ></v-text-field>
                                                            </v-col>

                                                        </v-row>
                                                        <v-row>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <h5 style="color:green">IVA RETENIDO </h5>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="iva_retenido" label="Tasa" ></v-text-field>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="importe_iva_retenido" label="Importe" ></v-text-field>
                                                            </v-col>

                                                        </v-row>
                                                        <v-row>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <h5 style="color:green">ISR RETENIDO </h5>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="isr_retenido" label="Tasa" ></v-text-field>
                                                            </v-col>
                                                            <v-col sm="4" md="4" lg="4">
                                                                <v-text-field v-model="importe_isr_retenido" label="Importe" ></v-text-field>
                                                            </v-col>

                                                        </v-row>
                                                        <p />
                                                    </v-card-text>
                                                </v-card>
                                            </v-form>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="default" small @click="modal = false">
                                            <v-icon small>mdi-cancel</v-icon> Cancelar
                                        </v-btn>
                                        <v-btn color="success" small @click="update">
                                            <v-icon small>mdi-check-circle-outline</v-icon> Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <h4>TOTAL A PAGAR: <b>{{total_factura}}</b></h4>
                        <p />
                        <v-spacer></v-spacer>

                        <v-btn color="success" large @click.native="timbrar()">
                            <v-icon>mdi-qrcode</v-icon> Generar CFDI de Pago
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
                <pre>

             
                </pre>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
    name: "DashboardDataTables",

    data: () => ({
        series: [],
        url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
        nota: "",
        menu1: false,
        menu2: false,
        actualiza: 1111,
        computedDateFormatted: "",
        iva_traslado: 0,
        iva_retenido: 0,
        isr_retenido: 0,
        importe_iva_traslado: 0,
        importe_iva_retenido: 0,
        importe_isr_retenido: 0,
        base_gravable: 0,
        model: {
            concarta: true,
            serie: "",
            folio: "",
            UsoCFDI: "G03",
            Moneda: "MXN",
            TipoDeComprobante: "T",
            LugarExpedicion: "06300",
            FormaPago: "03",
            UUID: "",
            FechaPago: "",
            FechaFactura: "",
            TipoCambio: "1",
            MetodoPago: "PUE",
            emisor: "",
            Pago: {
                No: "1",
                Saldo: "",
                Pagado: "",
                Insoluto: ""
            },
            receptor: {
                "registro_fiscal": ""
            },
            uuid_empresa: "",
            uuid_licencia: "",
            uuid: "",
            estatus: "",
            fecha: "",
            tipo: "",
            observaciones: "",
            index: 0
        },
        total_factura: "0.00",
        subtotal_factura: "0.00",
        imp_traslado_factura: "0.00",
        imp_retenido_factura: "0.00",

        isr_retenido: 0,
        descuento_factura: "0.00",
        iva_traslado: 0,
        iva_retenido: 0,
        descuento: 0,
        subtotal_producto: 0,
        total_producto: 0,
        producto: "",
        cantidad: 1,
        producto2: "",
        cantidad2: 1,
        nota: "",
        precio: 0,
        UsosCFDI: [],
        FormasPago: [],
        MetodosPago: [],
        Monedas: [{
                clave: "MXN",
                nombre: "PESO MEXICANO"
            },
            {
                clave: "USD",
                nombre: "DOLAR ESTADOUNIDENCE"
            },
            {
                clave: "EUR",
                nombre: "EURO"
            }
        ],
        TiposDeComprobante: [{
                clave: "T",
                nombre: "TRASLADO"
            },
            {
                clave: "I",
                nombre: "INGRESO"
            },
        ],
        timbre: "",
        tabla: "carta_porte",
        uuid_editando: "",
        con_mercancias: false,
        origenes: [],
        destinos: [],
        receptores: [],
        remolques: [],
        figuras: [],
        transportes: [],
        productos: [],
        mercancias: [],
        modal: false,
        usuario: "",
        clientes: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Pago",
                disabled: true,
                href: "",
            },
        ],
        rules: {},

        columns: ["SERIE", "FOLIO", "UUID", "NO", "SALDO", "PAGADO", "INSOLUTO", "TOTAL_IMPUESTOS", "actions"],
        options: {
            filterable: false,
            headings: {
                "SERIE": "SERIE",
                "FOLIO": "FOLIO",
                "UUID": "UUID",
                "NO": "NÚMERO DE PARCIALIDAD",
                "SALDO": "SALDO ANTERIOR",
                "PAGADO": "PAGADO",
                "INSOLUTO": "SALDO INSOLUTO",
                "TOTAL_IMPUESTOS": "IMPUESTOS",
                actions: "Operaciones"
            }
        },

        data_pagos: [],
    }),
    computed: {
        nombre() {
            let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
            return nombre_usuario;
        }
    },
    methods: {
        open(row, index) {

            this.model.UUID = row.UUID;
            this.model.Pago.No = row.NO;
            this.model.Pago.Saldo = row.SALDO;
            this.model.Pago.Pagado = row.PAGADO;
            this.model.Pago.Insoluto = row.INSOLUTO;

            this.iva_traslado = row.IMPUESTOS.iva_traslado;
            this.iva_retenido = row.IMPUESTOS.iva_retenido;
            this.isr_retenido = row.IMPUESTOS.isr_retenido;

            this.importe_iva_traslado = row.IMPUESTOS.importe_iva_traslado;
            this.importe_iva_retenido = row.IMPUESTOS.importe_iva_retenido;
            this.importe_isr_retenido = row.IMPUESTOS.importe_isr_retenido;

            if(parseFloat(row.IMPUESTOS.importe_iva_traslado) > 0)
                this.importe_iva_traslado = row.IMPUESTOS.importe_iva_traslado;
            else
                this.importe_iva_traslado = "0.00";

            if(parseFloat(row.IMPUESTOS.importe_iva_retenido) > 0)
                this.importe_iva_retenido = row.IMPUESTOS.importe_iva_retenido;
            else
                this.importe_iva_retenido = "0.00";

            if(parseFloat(row.IMPUESTOS.importe_isr_retenido) > 0)
                this.importe_isr_retenido = row.IMPUESTOS.importe_isr_retenido;
            else
                this.importe_isr_retenido = "0.00";


            this.model.index = index;
            this.modal = true;
        },
        recalcular(row, index) {

            this.model.UUID = row.UUID;
            this.model.Pago.No = row.NO;
            this.model.Pago.Saldo = row.SALDO;
            this.model.Pago.Pagado = row.PAGADO;
            this.model.Pago.Insoluto = row.INSOLUTO;

            this.iva_traslado = row.IMPUESTOS.iva_traslado;
            this.iva_retenido = row.IMPUESTOS.iva_retenido;
            this.isr_retenido = row.IMPUESTOS.isr_retenido;
            this.importe_iva_traslado = row.IMPUESTOS.importe_iva_traslado;
            this.importe_iva_retenido = row.IMPUESTOS.importe_iva_retenido;
            this.importe_isr_retenido = row.IMPUESTOS.importe_isr_retenido;

            let base = row.IMPUESTOS.base_gravable;

            this.model.index = index;
            if (parseFloat(this.model.Pago.Saldo) > 0 && parseFloat(this.model.Pago.Pagado) > 0)
                this.model.Pago.Insoluto = parseFloat(this.model.Pago.Saldo) - parseFloat(this.model.Pago.Pagado);
            else
                this.model.Pago.Insoluto = 0.00;

                var subtt = 0;
                var ax = 0;
                var bx = 0;
                var cx = 0;
                var xx = 0;


                if (parseFloat(this.isr_retenido) > 0){
                    this.importe_isr_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.isr_retenido))) ).toFixed(2);
                    cx = parseFloat(this.isr_retenido);
                }   
                else
                    this.importe_isr_retenido = "0.00";
                if (parseFloat(this.iva_retenido) > 0){
                    this.importe_iva_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1 + parseFloat(this.iva_retenido))) ).toFixed(2);
                    bx = parseFloat(this.iva_retenido);
                }
                else
                    this.importe_iva_retenido = "0.00";
                if (parseFloat(this.iva_traslado) > 0){
                    this.importe_iva_traslado = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.iva_traslado))) ).toFixed(2);
                    ax = parseFloat(this.iva_traslado);
                }
                else
                    this.importe_iva_traslado = "0.00";


                xx = ax - bx + cx;

                if (xx != 0) {
                    subtt = parseFloat(this.model.Pago.Pagado) / (xx + 1);
                    console.log("actualizando", subtt)
                    if (cx > 0) {
                        this.importe_isr_retenido = (subtt * parseFloat(this.isr_retenido)).toFixed(2);
                    }

                    if (bx > 0) {
                        this.importe_iva_retenido = (subtt * parseFloat(this.iva_retenido)).toFixed(2);
                    }

                    if (ax  > 0) {
                        this.importe_iva_traslado = (subtt * parseFloat(this.iva_traslado)).toFixed(2);
                    }
                }

            this.model.Pago.Insoluto = this.model.Pago.Insoluto.toFixed(2);
            var self = this;
            let i = index;

            self.data_pagos[i].NO = this.model.Pago.No;
            self.data_pagos[i].SALDO = this.model.Pago.Saldo;
            self.data_pagos[i].PAGADO = this.model.Pago.Pagado;
            self.data_pagos[i].INSOLUTO = this.model.Pago.Insoluto;

            if (parseFloat(this.isr_retenido) > 0)
                self.data_pagos[i].IMPUESTOS.importe_isr_retenido = this.importe_isr_retenido;
            else
                self.data_pagos[i].IMPUESTOS.importe_isr_retenido = "0.00";

            if (parseFloat(this.iva_retenido) > 0)
                self.data_pagos[i].IMPUESTOS.importe_iva_retenido = this.importe_iva_retenido;
            else
                self.data_pagos[i].IMPUESTOS.importe_iva_retenido = "0.00";

            if (parseFloat(this.iva_traslado) > 0)
                self.data_pagos[i].IMPUESTOS.importe_iva_traslado = this.importe_iva_traslado;
            else
                self.data_pagos[i].IMPUESTOS.importe_iva_traslado = "0.00";

            self.data_pagos[i].TOTAL_IMPUESTOS = parseFloat(this.importe_iva_traslado) - parseFloat(this.importe_iva_retenido) - parseFloat(this.importe_isr_retenido);
            self.data_pagos[i].IMPUESTOS.base_gravable = parseFloat(this.model.Pago.Pagado) - self.data_pagos[i].TOTAL_IMPUESTOS;

            self.data_pagos[i].TOTAL_IMPUESTOS = self.data_pagos[i].TOTAL_IMPUESTOS.toFixed(2);
            self.data_pagos[i].IMPUESTOS.base_gravable = self.data_pagos[i].IMPUESTOS.base_gravable.toFixed(2);

            self.data_pagos.push(self.data_pagos[i]);
            delete self.data_pagos[self.data_pagos.length - 1];

            this.totalpagar();
        },
        update() {
            var self = this;
            let index = self.model.index - 1;

            self.data_pagos[index].NO = this.model.Pago.No;
            self.data_pagos[index].SALDO = this.model.Pago.Saldo;
            self.data_pagos[index].PAGADO = this.model.Pago.Pagado;
            self.data_pagos[index].INSOLUTO = this.model.Pago.Insoluto;

            if (parseFloat(this.isr_retenido) > 0)
                self.data_pagos[index].IMPUESTOS.importe_isr_retenido = this.importe_isr_retenido;
            else
                self.data_pagos[index].IMPUESTOS.importe_isr_retenido = "0.00";
            if (parseFloat(this.iva_retenido) > 0)
                self.data_pagos[index].IMPUESTOS.importe_iva_retenido = this.importe_iva_retenido;
            else
                self.data_pagos[index].IMPUESTOS.importe_iva_retenido = "0.00";
            if (parseFloat(this.iva_traslado) > 0)
                self.data_pagos[index].IMPUESTOS.importe_iva_traslado = this.importe_iva_traslado;
            else
                self.data_pagos[index].IMPUESTOS.importe_iva_traslado = "0.00";

            self.data_pagos[index].TOTAL_IMPUESTOS = parseFloat(this.importe_iva_traslado) - parseFloat(this.importe_iva_retenido) - parseFloat(this.importe_isr_retenido);
            self.data_pagos[index].IMPUESTOS.base_gravable = parseFloat(this.model.Pago.Pagado) - self.data_pagos[index].TOTAL_IMPUESTOS;
            self.data_pagos[index].TOTAL_IMPUESTOS = self.data_pagos[index].TOTAL_IMPUESTOS.toFixed(2);
            self.data_pagos[index].IMPUESTOS.base_gravable = self.data_pagos[index].IMPUESTOS.base_gravable.toFixed(2);
            self.data_pagos.push(self.data_pagos[index]);
            delete self.data_pagos[self.data_pagos.length - 1];

            this.totalpagar();
            this.modal = false;
        },

        actualizaSaldo() {
            if (parseFloat(this.model.Pago.Saldo) > 0 && parseFloat(this.model.Pago.Pagado) > 0)
                this.model.Pago.Insoluto = parseFloat(this.model.Pago.Saldo) - parseFloat(this.model.Pago.Pagado);
            else
                this.model.Pago.Insoluto = 0.00;

            var subtt = 0;
            var ax = 0;
            var bx = 0;
            var cx = 0;
            var xx = 0;


            if (parseFloat(this.isr_retenido) > 0){
                this.importe_isr_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.isr_retenido))) ).toFixed(2);
                cx = parseFloat(this.isr_retenido);
            }   
            else
                this.importe_isr_retenido = "0.00";
            if (parseFloat(this.iva_retenido) > 0){
                this.importe_iva_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1 + parseFloat(this.iva_retenido))) ).toFixed(2);
                bx = parseFloat(this.iva_retenido);
            }
            else
                this.importe_iva_retenido = "0.00";
            if (parseFloat(this.iva_traslado) > 0){
                this.importe_iva_traslado = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.iva_traslado))) ).toFixed(2);
                ax = parseFloat(this.iva_traslado);
            }
            else
                this.importe_iva_traslado = "0.00";


            xx = ax - bx + cx;

            if (xx != 0) {
                subtt = parseFloat(this.model.Pago.Pagado) / (xx + 1);
                console.log("actualizando", subtt)
                if (cx > 0) {
                    this.importe_isr_retenido = (subtt * parseFloat(this.isr_retenido)).toFixed(2);
                }

                if (bx > 0) {
                    this.importe_iva_retenido = (subtt * parseFloat(this.iva_retenido)).toFixed(2);
                }

                if (ax  > 0) {
                    this.importe_iva_traslado = (subtt * parseFloat(this.iva_traslado)).toFixed(2);
                }
            }

            this.model.Pago.Insoluto = parseFloat(this.model.Pago.Insoluto).toFixed(2);
        },
        totalpagar() {
            this.total_factura = 0;
            var self = this;
            this.data_pagos.forEach(function (x) {
                self.total_factura += parseFloat(x.PAGADO);
            })
            self.total_factura = self.total_factura.toFixed(2);
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        cargarCatalogosSAT: function () {
            var self = this;

            this.$axios.post(this.URL_SAT + "list_usos_cfdi/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.UsosCFDI = res.data;
                    }
                });

            this.$axios.post(this.URL_SAT + "list_formas_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.FormasPago = res.data.sort(function (a, b) {
                            if (parseInt(a.clave) > parseInt(b.clave))
                                return 1;
                            if (parseInt(a.clave) < parseInt(b.clave))
                                return -1;
                            return 0;
                        });
                    }
                });

            this.$axios.post(this.URL_SAT + "list_metodos_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.MetodosPago = res.data;
                    }
                });

        },
        cargar: function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "filtros": {
                    "uuid": id
                }
            };
            axios.post(this.$hostname + 'carta_porte/list_pre_carta_porte/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.model = res.data[0];
                        if (self.model.concarta == true)
                            self.cargarDestinos();

                        self.calcular_totales();
                        self.cargarProductos();
                        self.$root.$dialogLoader.hide();
                    }

                });

        },

        cargarOrigenes: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.origenes = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarDestinos: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.destinos = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarEmisor: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                filtros: {
                    "uuid": this.model.uuid_empresa
                }
            };
            axios.post(self.URL_ADM + 'list_empresas/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.model.emisor = res.data[0];
                        self.model.LugarExpedicion = self.model.emisor.domicilio.codigo_postal;
                        if (res.data[0].catalogo_series != undefined && res.data[0].catalogo_series.length > 0) {
                            res.data[0].catalogo_series.forEach(function (x) {
                                self.series.push({
                                    "id": x.serie,
                                    "text": x.serie
                                });
                            });
                        }
                        self.cargarOrigenes();
                        self.cargarDestinos();

                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarReceptores: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "rfc": this.$local_storage.get('RFC_RECEPTOR')
            };
            axios.post(self.URL + 'list_clientes/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.receptores = res.data;

                        var filter = self.receptores;
                        self.model.receptor = filter[0];
                        if (filter.length == 0) {
                            let r = JSON.parse(self.$local_storage.get('RECEPTOR'));

                            var record = {};
                            record.rfc = r.Rfc;
                            record.razon_social = r.Nombre;
                            record.regimen_fiscal_receptor = r.RegimenFiscalReceptor;
                            record.domicilio = {};
                            if (r.Domicilio != undefined) {
                                record.domicilio.calle = r.Domicilio.Calle;
                                record.domicilio.codigo_postal = r.Domicilio.CodigoPostal;
                                record.domicilio.colonia = r.Domicilio.Colonia;
                                record.domicilio.estado = r.Domicilio.Estado;
                                record.domicilio.localidad = r.Domicilio.Localidad;
                                record.domicilio.municipio = r.Domicilio.Municipio;
                                record.domicilio.numero_ext = r.Domicilio.NumeroExterior;
                                record.domicilio.pais = r.Domicilio.Pais;
                            } else {
                                record.domicilio.calle = "";
                                record.domicilio.codigo_postal = "";
                                record.domicilio.colonia = "";
                                record.domicilio.estado = "";
                                record.domicilio.localidad = "";
                                record.domicilio.municipio = "";
                                record.domicilio.numero_ext = "";
                                record.domicilio.pais = "";
                            }

                            if (r.email != undefined)
                                record.email = r.Email;

                            self.receptores.push(record);
                            self.model.receptor = record;

                        }

                    }
                    self.$root.$dialogLoader.hide();
                });
        },

        validar: function () {
            var self = this;
            if (this.$refs.form.validate()) {
                if (self.model.concarta == true) {
                    if (self.model.hora_salida == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Salida",
                            footer: "",
                        });
                        return false;
                    }
                    if (self.model.hora_llegada == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Llegada",
                            footer: "",
                        });
                        return false;
                    }
                    const hs = new Date(self.model.hora_salida);
                    const he = new Date(self.model.hora_llegada);

                    if (hs > he) {
                        self.$swal({
                            type: "error",
                            title: "Datos Incorrectos",
                            text: "La Fecha y Hora de Salida no puede ser mayor a la de entrada",
                            footer: "",
                        });
                        return false;
                    }
                }

                return true;

            } else {
                self.$swal({
                    type: "error",
                    title: "Datos Incompletos",
                    text: "Verifique la informacón y vuelva a intentarlo",
                    footer: "",
                });
                return false;
            }

        },
        enviarTimbrar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            self.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "rfc": self.model.emisor.rfc,
                "json": self.timbre,
                "usuario": self.nombre
            };
            axios.post(self.url + 'carta_porte/guardar_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se envio correctamente. ",
                            footer: "No. de Solicitud: " + res.data.id_solicitud,
                        });
                        self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(res.data.id_solicitud));
                        self.$router.replace("/cartaporte");
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    self.$root.$dialogLoader.hide();
                });

        },

        cancelar: function () {

            this.$router.replace("/pre_carta_porte");
        },

        timbrar: function () {
            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");

                var self = this;

                var facturas = [];
                var f = {};

                let t_importe_isr_retenido = 0;
                let t_importe_iva_retenido = 0;
                let t_importe_iva_traslado = 0;
                let t_base_gravable = 0;

                this.data_pagos.forEach(function (x) {

                    f = {
                        "IdDocumento": x.UUID,
                        "MonedaDR": "MXN",
                        "EquivalenciaDR": "1",
                        "NumParcialidad": x.NO,
                        "ImpSaldoAnt": x.SALDO,
                        "ImpPagado": x.PAGADO,
                        "ImpSaldoInsoluto": x.INSOLUTO,
                        "ObjetoImpDR": x.esObjeto
                    };

                    if (x.IMPUESTOS.base_gravable > 0) {
                        x.IMPUESTOS.base_gravable = parseFloat(x.IMPUESTOS.base_gravable).toFixed(2).toString();
                    }
                    if (x.esObjeto == "02") {
                        f.ImpuestosDR = {};
                        if (parseFloat(x.IMPUESTOS.importe_iva_traslado) > 0) {
                            f.ImpuestosDR.TrasladosDR = [];
                            f.ImpuestosDR.TrasladosDR[0] = {
                                "BaseDR": x.IMPUESTOS.base_gravable,
                                "ImpuestoDR": "002",
                                "TipoFactorDR": "Tasa",
                                "ImporteDR": x.IMPUESTOS.importe_iva_traslado,
                                "TasaOCuotaDR": x.IMPUESTOS.iva_traslado
                            };
                            t_importe_iva_traslado += parseFloat(x.IMPUESTOS.importe_iva_traslado);
                            t_base_gravable += parseFloat(x.IMPUESTOS.base_gravable);
                        }
                        if (parseFloat(x.IMPUESTOS.importe_iva_retenido) > 0) {
                            f.ImpuestosDR.RetencionesDR = [];
                            f.ImpuestosDR.RetencionesDR.push({
                                "BaseDR": x.IMPUESTOS.base_gravable,
                                "ImpuestoDR": "002",
                                "TipoFactorDR": "Tasa",
                                "ImporteDR": x.IMPUESTOS.importe_iva_retenido,
                                "TasaOCuotaDR": x.IMPUESTOS.iva_retenido
                            });
                            t_importe_iva_retenido += parseFloat(x.IMPUESTOS.importe_iva_retenido);
                        }
                        if (parseFloat(x.IMPUESTOS.importe_isr_retenido) > 0) {
                            if (parseFloat(x.IMPUESTOS.importe_iva_retenido) == 0)
                                f.ImpuestosDR.RetencionesDR = [];
                            f.ImpuestosDR.RetencionesDR.push({
                                "BaseDR": x.IMPUESTOS.base_gravable,
                                "ImpuestoDR": "001",
                                "TipoFactorDR": "Tasa",
                                "ImporteDR": x.IMPUESTOS.importe_isr_retenido,
                                "TasaOCuotaDR": x.IMPUESTOS.isr_retenido
                            });
                            t_importe_isr_retenido += parseFloat(x.IMPUESTOS.importe_isr_retenido);

                        }

                    }
                    facturas.push(f);
                });

                let impuestos_pago = {};
                let totales = {};
                //  self.timbre.Complemento.Pagos.Pago[0].ImpuestosP = {};
                // self.timbre.Complemento.Pagos.Totales.

                if (parseFloat(t_importe_iva_retenido) > 0 || parseFloat(t_importe_isr_retenido) > 0) {
                    impuestos_pago.RetencionesP = [];
                    if (parseFloat(t_importe_iva_retenido) > 0) {
                        impuestos_pago.RetencionesP.push({
                            "ImpuestoP": "002",
                            "ImporteP": t_importe_iva_retenido.toFixed(2).toString(),
                        }, );
                        totales.TotalRetencionesIVA = t_importe_iva_retenido.toFixed(2).toString();
                    }
                    if (parseFloat(t_importe_isr_retenido) > 0) {
                        impuestos_pago.RetencionesP.push({
                            "ImpuestoP": "001",
                            "ImporteP": t_importe_isr_retenido.toFixed(2).toString(),
                        }, );
                        totales.TotalRetencionesISR = t_importe_isr_retenido.toFixed(2).toString();
                    }

                }
                if (parseFloat(t_importe_iva_traslado) > 0) {
                    impuestos_pago.TrasladosP = [];
                    totales.TotalTrasladosBaseIVA16 = t_base_gravable.toFixed(2).toString();
                    impuestos_pago.TrasladosP.push({
                        "BaseP": totales.TotalTrasladosBaseIVA16,
                        "ImpuestoP": "002",
                        "TipoFactorP": "Tasa",
                        "ImporteP": t_importe_iva_traslado.toFixed(2).toString(),
                        "TasaOCuotaP": "0.160000"
                    });

                    totales.TotalTrasladosImpuestoIVA16 = t_importe_iva_traslado.toFixed(2).toString();
                }

                totales.MontoTotalPagos = self.total_factura;

                let lugar = self.model.LugarExpedicion;
                if (self.model.receptor.rfc != 'XAXX010101000') {
                    lugar = self.model.receptor.domicilio.codigo_postal;
                }

                self.timbre = {
                    "Version": "4.0",
                    "SubTotal": "0",
                    "Total": "0",
                    "Serie": "",
                    "Folio": "",
                    "Exportacion": "01",
                    "NoCertificado": "",
                    "Fecha": this.model.FechaFactura + 'T00:00:00',
                    "Moneda": "XXX",
                    "TipoDeComprobante": "P",
                    "LugarExpedicion": self.model.LugarExpedicion,
                    "Emisor": {
                        "Nombre": self.model.emisor.razon_social,
                        "RegimenFiscal": self.model.emisor.regimen,
                        "Rfc": self.model.emisor.rfc,
                        "Domicilio": {
                            "Calle": self.model.emisor.domicilio.calle,
                            "CodigoPostal": self.model.emisor.domicilio.codigo_postal,
                            "Colonia": self.model.emisor.domicilio.colonia,
                            "Estado": self.model.emisor.domicilio.estado,
                            "Localidad": self.model.emisor.domicilio.localidad,
                            "Municipio": self.model.emisor.domicilio.municipio,
                            "NumeroExterior": self.model.emisor.domicilio.numero_ext,
                            "Pais": self.model.emisor.domicilio.pais,
                            "Referencia": ""
                        },
                    },
                    "Receptor": {
                        "Rfc": self.model.receptor.rfc,
                        "Nombre": self.model.receptor.razon_social,
                        "UsoCFDI": "CP01",
                        "RegimenFiscalReceptor": self.model.receptor.regimen_fiscal_receptor,
                        "DomicilioFiscalReceptor": lugar,
                        "Domicilio": {
                            "Calle": self.model.receptor.domicilio.calle,
                            "CodigoPostal": self.model.receptor.domicilio.codigo_postal,
                            "Colonia": self.model.receptor.domicilio.colonia,
                            "Estado": self.model.receptor.domicilio.estado,
                            "Localidad": self.model.receptor.domicilio.localidad,
                            "Municipio": self.model.receptor.domicilio.municipio,
                            "NumeroExterior": self.model.receptor.domicilio.numero_ext,
                            "Pais": self.model.receptor.domicilio.pais,
                            "Referencia": ""
                        },
                        "Email": self.model.receptor.email
                    },
                    "Conceptos": [{
                        "Cantidad": "1",
                        "ClaveProdServ": "84111506",
                        "ClaveUnidad": "ACT",
                        "Descripcion": "Pago",
                        "Importe": "0",
                        "ValorUnitario": "0",
                        "ObjetoImp": "01"
                    }],

                    "Complemento": {
                        "Pagos": {
                            "Version": "2.0",
                            "Totales": {
                                "MontoTotalPagos": self.total_factura
                            },
                            "Pago": [{
                                "FechaPago": self.model.FechaPago + 'T00:00:00',
                                "FormaDePagoP": self.model.FormaPago,
                                "MonedaP": "MXN",
                                "Monto": self.total_factura,
                                "TipoCambioP": "1",
                                "DoctoRelacionado": facturas
                            }]
                        }
                    },

                };

                let total_impuestos = parseFloat(t_importe_iva_traslado) + parseFloat(t_importe_iva_traslado) + parseFloat(t_importe_iva_traslado);
                if (total_impuestos > 0) {
                    self.timbre.Complemento.Pagos.Totales = totales;
                    self.timbre.Complemento.Pagos.Pago[0].ImpuestosP = impuestos_pago;
                    //   self.timbre.Conceptos[0].ObjetoImp = "02";

                }
                if (parseInt(self.model.folio) > 0) {
                    self.timbre.Folio = self.model.folio;
                }
                self.timbre.Serie = self.model.serie;

                this.$root.$dialogLoader.hide();

                this.enviarTimbrar();

            }
        },

    },
    created: function () {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        this.rules = this.$rules;
        this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
        this.model.uuid_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));

        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_ADM = this.$hostname + "carta_porte/administracion/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";

        this.cargarEmisor();
        this.cargarReceptores();

        this.cargarCatalogosSAT();

        /*   var f_a = new Date();
          let y = f_a.getFullYear();
          let m = f_a.getMonth() + 1;
          let d = f_a.getDate();

          if (m < 10)
              m = '0' + m;

          if (d < 10)
              d = '0' + d;

          let fecha_a = y + "-" + m + "-" + d;
          this.model.FechaPago = fecha_a; */
        this.model.FechaPago = moment().format("YYYY-MM-DD");
        this.model.FechaFactura = moment().format("YYYY-MM-DD");

        this.data_pagos = JSON.parse(this.$local_storage.get('pagos'));
        
        let self = this;
        let i = 0;
        self.total_factura = 0;
        this.data_pagos.forEach(function (x) {
            self.$local_storage.set('RFC_RECEPTOR', x.RFC_RECEPTOR);
            x.NO = 1;
            x.SALDO = x.TOTAL;
            x.PAGADO = x.TOTAL;

            x.INSOLUTO = 0.00;
            self.total_factura += parseFloat(x.PAGADO);

            x.TOTAL_IMPUESTOS = parseFloat(x.IMPUESTOS.TotalImpuestosTrasladados) - parseFloat(x.IMPUESTOS.TotalImpuestosRetenidos);
            x.TOTAL_IMPUESTOS = parseFloat(x.TOTAL_IMPUESTOS.toFixed(2));

            if (x.TOTAL_IMPUESTOS > 0)
                x.esObjeto = "02";
            else
                x.esObjeto = "01";

            let total = x.TOTAL - x.TOTAL_IMPUESTOS;
            total = parseFloat(total.toFixed(2));

            let subtotal = x.SUBTOTAL;

            self.base_gravable = subtotal;

            if (x.IMPUESTOS != undefined) {
                if (x.IMPUESTOS.Traslados != undefined)
                    x.IMPUESTOS.Traslados.forEach(function (T) {
                        if (T.Impuesto == "002") {
                            x.IMPUESTOS.iva_traslado = T.TasaOCuota;
                            x.IMPUESTOS.base_gravable = T.Base;
                            x.IMPUESTOS.importe_iva_traslado = T.Importe;
                            if (x.IMPUESTOS.iva_traslado == '0.1600')
                                x.IMPUESTOS.iva_traslado = "0.160000"
                        }
                    });
                if (x.IMPUESTOS.Retenciones != undefined)
                    x.IMPUESTOS.Retenciones.forEach(function (R) {
                        if (R.Impuesto == "001") {
                            x.IMPUESTOS.importe_isr_retenido = R.Importe;
                            x.IMPUESTOS.isr_retenido = ((R.Importe / self.base_gravable) * 100) / 100;
                            x.IMPUESTOS.isr_retenido = x.IMPUESTOS.isr_retenido.toFixed(6);

                        }
                        if (R.Impuesto == "002") {
                            x.IMPUESTOS.importe_iva_retenido = R.Importe;
                            x.IMPUESTOS.iva_retenido = ((R.Importe / self.base_gravable) * 100) / 100;

                            if (x.IMPUESTOS.iva_retenido.toFixed(4) == "0.1066")
                                x.IMPUESTOS.iva_retenido = "0.106666";
                            else
                                x.IMPUESTOS.iva_retenido = x.IMPUESTOS.iva_retenido.toFixed(6);
                        }
                    });
            }
            self.recalcular(x, i);
            i = i + 1;
        });
        self.total_factura = parseFloat(self.total_factura).toFixed(2);
        self.$local_storage.set("pagos", "[]");
        self.$store.state.pagos = 0;
    },

};
</script>
